import GenericRequest, { METHOD_GET } from '../../../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../../../shared/webservices/endpoint';

export class MachineStateListTask extends GenericRequest {

    constructor() {
        super(METHOD_GET, ApiEndpoints.MACHINES_STATE);
    }

    overrideRequest() {}
}



// WEBPACK FOOTER //
// ./src/app/my-outsources/machine/list/machine-state-list/MachineStateListTask.js